exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\ntextarea[data-v-75c2049d] {\n  padding-top: 7px;\n  transition: height .5s;\n}\n", "", {"version":3,"sources":["/home/runner/work/online-store/online-store/src/components/common/BaseResizeableTextArea.vue"],"names":[],"mappings":";AAAA;EACE,iBAAiB;EACjB,uBAAuB;CAAE","file":"BaseResizeableTextArea.vue","sourcesContent":["textarea {\n  padding-top: 7px;\n  transition: height .5s; }\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?sourceMap!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-75c2049d","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/BaseResizeableTextArea.vue
// module id = Ves0
// module chunks = 18